import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    categories:[
      {active: false, label: "自社", icon: "mdi-domain"},
      {active: false, label: "private", icon: "mdi-home-variant-outline"},
    ],
    tasks:[
      {active: false, label: "mail", icon: "mdi-email-outline"},
      {active: false, label: "tel", icon: "mdi-phone-outline"},
      {active: false, label: "chat", icon: "mdi-forum-outline"},
      {active: false, label: "coding", icon: "mdi-code-tags"},
      {active: false, label: "test", icon: "mdi-format-list-checkbox"},
      {active: false, label: "review", icon: "mdi-file-find-outline"},
      {active: false, label: "research", icon: "mdi-magnify"},
      {active: false, label: "meeting", icon: "mdi-sleep"},
      {active: false, label: "lunch", icon: "mdi-food-outline"},
      {active: false, label: "move", icon: "mdi-walk"},
      {active: false, label: "break", icon: "mdi-coffee"},
      {active: false, label: "learn", icon: "mdi-book-open-blank-variant"},
    ],
    logs:[],
    waiting:{
      start:"",
      end:""
    },
    accepted: 0
  },
  mutations: {
    saveCategories(state, categories){
      state.categories = categories;
    },
    saveTasks(state, tasks){
      state.tasks = tasks;
    },
    addStartLog(state, log) {
      state.logs.push(log);
      state.waiting.start = "";
    },
    addEndLog(state, timestamp) {
      if(state.logs.length === 0) return;
      let log = state.logs[state.logs.length-1];
      if(log.end) return;
      log.end = timestamp;
    },
    setWaitingStart(state, id){
      state.waiting.start=id;
    },
    setWaitingEnd(state, id){
      state.waiting.end=id;
    },
    clearWaitingStart(state){
      state.waiting.start = "";
    },
    clearWaitingEnd(state){
      state.waiting.end = "";
    },
    acceptCookie(state, isAccept){
      state.accepted = isAccept;
    },
    gabageLogs(state){
      let dt = new Date();
      dt.setDate(dt.getDate() -7);
      let target = dt.getTime();
      state.logs = state.logs.filter(x => !x.end || x.start > target);
    }
  },
  actions: {
    saveCategories({commit}, categories){
      commit('saveCategories', categories);
    },
    saveTasks({commit}, tasks){
      commit('saveTasks', tasks);
    },
    addStartLog({commit}, log) {
      let newLog = {
        start: new Date().getTime(),
        end: "",
        category:log.category,
        task: log.task
      }

      // 同じ項目を解除してすぐに再開した場合は操作をキャンセル
      if(this.state.logs.length !== 0) {
        let latestLog = this.state.logs[this.state.logs.length-1]
        if(latestLog.end === ""
          && latestLog.category === newLog.category
          && latestLog.task === newLog.task
          && this.state.waiting.end !== "") {
          clearTimeout(this.state.waiting.end);
          commit('clearWaitingEnd');
          return;
        }
      }

      // 登録予約
      let id = setTimeout(() => {
        commit('addStartLog', newLog);
      }, 1000);
      commit('setWaitingStart', id);
    },
    addEndLog({commit}){
      // 登録待ちが存在する場合はキャンセル
      if(this.state.waiting.start) {
        clearTimeout(this.state.waiting.start);
        clearTimeout(this.state.waiting.end);
        commit('clearWaitingStart');
        if(this.state.waiting.end === "") {
          return;
        }
      }

      let id = setTimeout(() => {
        commit('addEndLog', new Date().getTime());
        commit('clearWaitingEnd');
      }, 1000);
      commit('setWaitingEnd', id);
    },
    acceptCookie({commit}, isAccept){
      commit('acceptCookie', isAccept);
    },
    gabageLogs({commit}){
      commit('gabageLogs');
    }
  },
  modules: {
  },
  plugins: [createPersistedState({
    key: 'MyLog',
    storage: window.localStorage
  })]
})
